import React from 'react';
import HeroSection from '../HeroSection';

function ElektraAanleggenHero() {
  return (
    <HeroSection 
      title="Professionele elektra aanleg voor uw woning"
      description="Van nieuwbouw tot uitbreiding: onze experts zorgen voor een veilige en toekomstbestendige elektrische installatie."
      imageSrc="/images/mark.png"

    />
  );
}

export default ElektraAanleggenHero;